import mountSiteHeader from 'react/layout/header/mountSiteHeader';

// Every flatlab page prints the header root. Mount it now, not on DOM ready:
// the bundle loads at the end of the body, and the scripts after this one
// expect the header in place.
mountSiteHeader(document);
